import React, { useState, useContext } from 'react';
import { Button } from '@fluentui/react-components';
import { CheckmarkRegular, WarningRegular } from '@fluentui/react-icons';
import moment from 'moment';
import { IMilestoneRule, IFinancialStatementProcess } from '../Interfaces';
import { warningClass, iconClass, completeClass } from './Gate.Styles';
import ReasonForViolationEditPanel from '../panels/ReasonForViolationEditPanel';
import ProcessContext from '../ProcessContext';
import useIsMounted from '../../../common/IsMountedHook';

interface IReasonForViolationGateProps {
  rule: IMilestoneRule;
  milestoneId: number;
  disabled: boolean;
  isMilestoneComplete: boolean;
}

const ReasonForViolationGate = ({
  rule,
  milestoneId,
  disabled,
  isMilestoneComplete,
}: IReasonForViolationGateProps): JSX.Element => {
  const [panelIsOpen, setIsPanelOpen] = useState(false);
  const isMounted = useIsMounted();

  const data = useContext(ProcessContext);

  const processDetail: IFinancialStatementProcess = data || {};
  const isBeforeFilingDueDate = (): boolean => {
    if (isMilestoneComplete) return false;
    const isBeforeFilingDueDateUTC =
      moment.utc(new Date()).startOf('day') <= moment(processDetail.filingDueDate);
    return isBeforeFilingDueDateUTC;
  };
  const ruleIsComplete = (): boolean => {
    if (isMilestoneComplete) return true;
    return rule.isComplete;
  };
  const closePanel = (): void => {
    if (isMounted.current) {
      setIsPanelOpen(false);
    }
  };

  const buttonText = ruleIsComplete()
    ? 'View or edit reason for filing violation'
    : 'Enter a reason for filing violation';

  const renderIcon = () => {
    if (ruleIsComplete()) {
      return <CheckmarkRegular className={`${iconClass} ${completeClass}`} />;
    }
    if (isBeforeFilingDueDate()) {
      return <CheckmarkRegular className={`${iconClass} ${completeClass}`} />;
    }
    return <WarningRegular className={`${iconClass} ${warningClass}`} />;
  };

  return (
    <>
      <Button
        appearance="transparent"
        onClick={(): void => {
          setIsPanelOpen(true);
        }}
        aria-label={buttonText}
        style={{ textAlign: 'start' }}
      >
        {renderIcon()}
        {buttonText}
      </Button>
      {panelIsOpen && data && (
        <ReasonForViolationEditPanel processDetail={processDetail} closePanel={closePanel} />
      )}
    </>
  );
};

export default ReasonForViolationGate;
